import React from 'react';

const SocialMediaIcons: React.FC = () => {
  return (
    <div className="social-media-icons">
      <a href="https://www.facebook.com/srisailamfoundation.org" className="social-icon facebook-icon" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="https://x.com/srisailamfndn" className="social-icon twitter-icon" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-twitter"></i>
      </a>
      <a href="https://www.instagram.com/srisailamfoundation" className="social-icon instagram-icon" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i>
      </a>
      {/* <a href="https://youtube.com" className="social-icon youtube-icon" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-youtube"></i>
      </a> */}
    </div>
  );
};

export default SocialMediaIcons;